import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class BobInAnimation extends Animation {

    private readonly type: "left" | "right";
    private readonly quick: boolean;

    constructor(type: "left" | "right", quick: string) {
        super();
        this.type = type;
        this.quick = quick === "quick";
    }

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const x = this.type === "right" ? this.getRightmostPosition(item, context) : this.getLeftmostPosition(item, context);
        const y = item.y - (this.quick ? 40 : 100);
        const rotation = (this.quick ? 0.5 : 1) * 20 * Math.PI / 180;
        let moveComplete: boolean = false;
        const rotate = (sign: number) => {
            item.tweenTo(0.2 * (this.quick ? 0.25 : 1), this.quick ? Ease.none : Ease.sineInOut, {
                y,
                rotation: sign * rotation,
                repeat: 1,
                yoyo: true,
                onUpdate: () => this.updatePaperCut(item),
                onComplete: () => {
                    if (!moveComplete) {
                        rotate(-sign);
                    }
                },
            });
        };
        item.moveXFrom(x,
            Math.abs(item.x - x) / ((this.speed || 1) * 800),
            Ease.sineOut,
            {
                delay: this.delay,
                onStart: () => {
                    rotate(this.type === "right" ? 1 : -1);
                },
                onUpdate: () => {
                    this.updatePaperCut(item);
                    this.onUpdate();
                },
                onComplete: () => {
                    moveComplete = true;
                    this.onComplete();
                    cb();
                },
            },
        );
        if (this.delay) {
            this.updatePaperCut(item);
        }
    }
}
